<template>
      <v-card elevation="1">
        <v-card-title>{{computedTitle}}</v-card-title>
        <v-card-text>
          <v-row>
            <col12>
          <filter-group style="margin-top: 10px;"
                        @set_value="set_value"
                        @clear_filter_id="clear_filter_id" 
                        :filters="filters"
                        :non_deletable_filter_types="non_deletable_filter_types"
                        :non_togglable_filter_types="non_togglable_filter_types"></filter-group>
          <add-filter @load="load" :initial_filter="initial_filter" style="margin-top: 30px;" @add_filter="add_filter"></add-filter>
              <div style="max-width: 250px;" v-if="show_limit"><v-text-field :label="$t('filter_tree.limit')" v-model="limit" rounded filled dense outlined type="text"></v-text-field></div>
          <v-btn v-if="show_button" color="primary" @click.native="load" style="float:none; margin-left:0px; margin-top: 15px" id="load_button" class="button">
            {{$t('filter_tree.btn_load')}}
          </v-btn>
          <div v-if="max_results !== false">
            {{$t('settings_tasks.edit_filter_tree_max_results')}} {{max_results}}
          </div>
              </col12>
            </v-row>

        </v-card-text>
      </v-card>

</template>

<script>
import FilterGroup from "@/components/asset_filter/FilterGroup";
import AddFilter from "@/components/asset_filter/AddFilter";
const { v4: uuidV4 } = require('uuid');
import Col12 from "@/components/layout/Col12";
export default {
  name: "FilterTree",
  components: {Col12, AddFilter, FilterGroup},
  props: {
    'max_results': {required: true},
    'show_limit': {default: true},
    'initial_filter': {default: false},
    'show_button': {default: true},
    'title': { default: null },
    'loadedFilters': {default: null},
    'loadedLimit': {default: null},
    'non_deletable_filter_types': {default: () => []},
    'non_togglable_filter_types': {default: () => []}
  },
  computed: {
    translatedTitle() {
      return this.$t('settings_tasks.edit_title_filter_tree');
    },
    computedTitle() {
      return this.title !== null ? this.title : this.translatedTitle;
    }
  },

  data() {
    return {
      filters: [],
      limit: 12
    }
  },
  watch: {
    filters() {
      this.$emit('update', this.filters, this.limit)
    },
    limit() {
      this.$emit('update', this.filters, this.limit)
    },
    loadedFilters: {
      handler(newFilters) {
        if (newFilters && Array.isArray(newFilters)) {
          // Deep copy to avoid reference issues
          this.$set(this, 'filters', JSON.parse(JSON.stringify(newFilters)));
        }
      },
      deep: true,
      immediate: false
    },
    loadedLimit: {
      handler(newLimit) {
        if (newLimit !== null && newLimit !== undefined) {
          this.$set(this, 'limit', newLimit);
        }
      },
      immediate: false
    }
  },
  mounted() {
    // Note: initial_filter is handled by AddFilter component which loads full filter metadata from API
    // No need to initialize here to avoid duplicates
  },
  methods: {
    add_filter(filter) {
      // Always add a new filter, allowing multiple filters of the same type
      // (e.g., multiple "Meta contains" filters with different values)
      filter.id = filter.id || uuidV4();
      if (filter.options && filter.options.length > 0 && !filter.value && filter.options[0] === 'Yes') {
        filter.value = filter.options[0]
      }
      this.filters.push(filter)
    },
    load() {
      this.$emit('load', this.filters, this.limit);
    },
    clear_filter_id(filter_id) {
      // Find the filter to check if it's non-deletable
      const filterToRemove = this.filters.find(f => f.id === filter_id);
      if (filterToRemove && this.non_deletable_filter_types.includes(filterToRemove.type)) {
        // Don't allow deletion of non-deletable filter types
        return;
      }
      let filters = this.filters.filter(f=>{ return f.id !== filter_id})
      this.$set(this, 'filters', filters)
    },
    set_value(filter_id, value) {
      let filterIds = this.filters.map(f=>{return f.id});
      let i = filterIds.indexOf(filter_id)
      const filter = this.filters[i];
      // Prevent toggling non-togglable filter types
      if (this.non_togglable_filter_types.includes(filter.type)) {
        // Force the value to stay as "Yes" for groupedBy filter
        if (filter.type === 41) {
          this.$set(this.filters[i], 'value', 'Yes');
          return;
        }
      }
      this.$set(this.filters[i], 'value', value)
    },
    async loadFilters(filters, limit) {
      if (filters && Array.isArray(filters)) {
        // Enrich saved filters with full metadata from API to avoid duplicates
        try {
          const filterOptions = await this.$api.asset.filter_options();
          const enrichedFilters = filters.map(savedFilter => {
            // Find matching filter option by type
            const matchingOption = filterOptions.find(opt => opt.type === savedFilter.type);
            if (matchingOption) {
              // Merge saved filter values with full metadata
              const enriched = JSON.parse(JSON.stringify(matchingOption));
              enriched.id = savedFilter.id || uuidV4();
              enriched.value = savedFilter.value !== undefined ? savedFilter.value : enriched.value;
              return enriched;
            }
            // If no match found, return saved filter as-is
            return {
              ...savedFilter,
              id: savedFilter.id || uuidV4()
            };
          });
          this.$set(this, 'filters', enrichedFilters);
        } catch (error) {
          console.error('Error enriching filters:', error);
          // Fallback: use saved filters as-is
          const filtersWithIds = filters.map(f => ({
            ...f,
            id: f.id || uuidV4()
          }));
          this.$set(this, 'filters', filtersWithIds);
        }
      }
      if (limit !== null && limit !== undefined) {
        this.$set(this, 'limit', limit);
      }
    }
  }
}
</script>

<style scoped>

</style>